import React from 'react'
import { withStyles } from '@material-ui/core/styles'
import { withTranslate } from 'react-redux-multilingual'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import Autocomplete from '@material-ui/lab/Autocomplete'

function FindPropertyCard({
  classes,
  translate,
  properties,
  onSearchInput,
  onSelectProperty
}) {
  return (
    <Card className={classes.card} raised>
      <CardHeader
        title="Checkin"
        subheader={translate('findPropertySubHeader')}
      />
      <CardContent>
        <Autocomplete
          id="combo-box-demo"
          options={properties}
          getOptionLabel={(option) => option.label}
          onChange={(_, selected) => onSelectProperty(selected)}
          style={{ width: '100%' }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={translate('findPropertyByName')}
              onChange={onSearchInput}
              variant="outlined"
              fullWidth
            />
          )}
        />
      </CardContent>
    </Card>
  )
}

const styles = (theme) => ({
  card: {
    maxWidth: 800,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(6))]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  }
})

export default withStyles(styles)(withTranslate(FindPropertyCard))
